<template>
    <div>
        <div v-if="assets.length > 0">
            <ul class="item-list">
                <template v-if="layout_type === 'artifacts'">
                    <template v-for="(artifact,index) in assets" :key="index">
                        <li v-if="artifact.asset !== null">
                            <ArtifactItem :artifact="artifact"/>
                        </li>
                    </template>
                </template>
                <template v-else>
                    <li v-for="(asset,index) in assets" :key="index">
                        <AssetItem :asset="asset" :layout_type="layout_type"/>
                    </li>
                </template>
            </ul>
            <Pagination v-if="show_pagination && last_page !== null" @goToPage="getAssetByType"
                        :current_page="current_page"
                        :last_page="last_page"/>
        </div>
        <div v-else-if="is_no_result" class="d-flex justify-content-center">
            <p>No result</p>
        </div>
        <div v-else class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p>Loading...</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Pagination from "./Pagination";
import AssetItem from "./AssetItem";
import ArtifactItem from "./ArtifactItem";

export default {
    name: "AssetList",
    components: {ArtifactItem, AssetItem, Pagination},
    props: {
        layout_type: {
            type: String,
            default: 'assets'
        },
        is_no_result: {
            type: Boolean,
            default: false
        },
        per_page: {
            type: Number,
            default: 30
        },
        show_pagination: {
            type: Boolean,
            default: false
        },
        selectedTypes: {
            type: Array,
            default: []
        },
        selectedAreas: {
            type: Array,
            default: []
        },
        selectedSites: {
            type: Array,
            default: []
        },
        selectedTags: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            assets: [],
            lang: lang,
            current_page: 1,
            last_page: null
        }
    },
    created() {
        this.getAssetByType()
    },
    methods: {
        getAssetByType(page = 1) {
            window.history.scrollRestoration = "manual"
            window.scrollTo(0, 0)
            this.assets = []
            let params = {
                per_page: this.per_page,
                page: page
            }
            if (this.selectedTypes.length > 0) {
                params['_types'] = this.selectedTypes.join(',')
            }
            if (this.selectedAreas.length > 0) {
                params['_areas'] = this.selectedAreas.join(',')
            }
            if (this.selectedSites.length > 0) {
                params['_sites'] = this.selectedSites.join(',')
            }
            if (this.selectedTags.length > 0) {
                params['_tags'] = this.selectedTags.join(',')
            }
            params['lang'] = this.lang
            const config = {
                params: params,
            }
            axios.get('/api/' + this.layout_type, config)
                .then((res) => {
                    if (res.data.meta.total === 0) {
                        this.is_no_result = true
                    }
                    this.assets = res.data.data
                    this.current_page = res.data.meta.current_page
                    this.last_page = res.data.meta.last_page
                    if (this.show_pagination === true) {
                        this.$emit('setTotal', res.data.meta.total)
                    }
                })
        }

    }
}
</script>

<style scoped>

</style>
